export default __webpack_public_path__ + "static/media/141.787cd127.jpg";